import { formatCurrency } from '@common/lib/currency';

import { PRODUCT_BY_ID } from '../constants/productCatalog';

interface ProductSelectionSummaryProps {
	selectedIds: Set<string>;
	totalMonthly: number;
	/** Per-product display prices in cents, keyed by productId. Falls back to catalog price. */
	displayPrices?: Record<string, number>;
}

/**
 * Receipt-style summary showing selected products and total monthly cost.
 */
export default function ProductSelectionSummary({
	selectedIds,
	totalMonthly,
	displayPrices,
}: ProductSelectionSummaryProps) {
	if (selectedIds.size === 0) return null;

	const selectedProducts = [...selectedIds].map((id) => PRODUCT_BY_ID.get(id)).filter(Boolean);

	const formattedTotal = formatCurrency(totalMonthly / 100, '—', false);

	return (
		<div className='onboarding-step__selection-summary'>
			<div className='onboarding-step__selection-summary-items'>
				{selectedProducts.map((product) => {
					const cents = displayPrices?.[product!.id] ?? product!.priceMonthly;
					const priceLabel = `${formatCurrency(cents / 100, '—', false)}/mo`;
					return (
						<div key={product!.id} className='onboarding-step__selection-summary-item'>
							<span>{product!.name}</span>
							<span>{priceLabel}</span>
						</div>
					);
				})}
			</div>
			<div className='onboarding-step__selection-summary-total'>
				<span>Total</span>
				<span>{formattedTotal}/mo</span>
			</div>
		</div>
	);
}
